module.exports = __webpack_public_path__ + "static/media/personalized-learning-cpu-gear-icon_2-color.3af7c67a.svg";